export class Atendimento {
  constructor ({
 id,
    atendimento_id,
    unidade_negocio_id,
    user_id,
    nome_produtor,
    nome_fazenda,
    data_atendimento,
    observacao,
    itens,
    valor_total,
    fazenda_id,
    produtor_id,
    fazenda_produtor_id,
    tipo_atendimento,
    tecnico_id,
    itens_servicos,
    plano_pagamento_id,
    tecnico_setor_id,
  } = {
    id: null,
    atendimento_id: '',
    user_id: 0,
    unidade_negocio_id: '',
    nome_produtor: '',
    nome_fazenda: '',
    data_atendimento: '',
    observacao: '',
    valor_total: 0,
    fazenda_id: '',
    produtor_id: '',
    fazenda_produtor_id: '',
    itens: [],
    tecnico_id: null,
    itens_servicos: [],
    plano_pagamento_id: null,
    tecnico_setor_id: null,
  }) {
    this.id = id
    this.atendimento_id = atendimento_id
    this.unidade_negocio_id = unidade_negocio_id
    this.user_id = user_id
    this.nome_produtor = nome_produtor
    this.nome_fazenda = nome_fazenda
    this.data_atendimento = data_atendimento
    this.observacao = observacao
    this.valor_total = valor_total
    this.fazenda_id = fazenda_id
    this.produtor_id = produtor_id
    this.fazenda_produtor_id = fazenda_produtor_id
    this.tipo_atendimento = tipo_atendimento
    this.itens = itens.map(({ ...item }) => {
      return {
        ...item,
      }
    })
    this.tecnico_id = tecnico_id
    this.itens_servicos = itens_servicos.map(({ ...item }) => {
      return {
        ...item,
      }
    })
    this.plano_pagamento_id = plano_pagamento_id
    this.tecnico_setor_id = tecnico_setor_id
  }
}

export function createAtendimento (data) {
  return Object.freeze(new Atendimento(data))
}
